import { NotificationManager } from 'react-notifications';
import {
  getIssuerReqHistoryRequest,
  getReqHistoryRequest
} from 'src/api/RequestHistoryRequest';
import { checkRequestError } from '.';
import { GET_REQ_HISTORY } from '../types';

export const getReqHistoryAction = (filterObj, profile) => async (dispatch) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getReqHistoryRequest(filterObj)
        : await getIssuerReqHistoryRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GET_REQ_HISTORY, payload: data.content.data?.all || [] });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.info(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};
